import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App.tsx';
import './index.css';

// Ensure the root element exists before rendering
const container = document.getElementById('root');
if (!container) throw new Error("Failed to find the root element");

const root = createRoot(container);

import { HelmetProvider } from 'react-helmet-async';

root.render(
  <StrictMode>
    <HelmetProvider>
      <App />
    </HelmetProvider>
  </StrictMode>
);